<template>
    <div class="main" ref="content">
        <nav class="nav flex" ref="nav">
            <span v-for="(item, i) in navs" :class="curNav == i ? 'cur' : ''" :key="i" @click="onChangeNav(item, i)">
                {{ item }}
            </span>
        </nav>
        <div class="content" v-show="curNav == 0">
            <TodayNorthAmount />
            <HistoryNorthAmount />
            <HistoryNorthData />
        </div>
        <div class="content" v-show="curNav == 1">
            <GeGu />
        </div>
        <div class="content" v-show="curNav == 2">
            <BanKuai />
        </div>
        <div class="content" v-show="curNav == 3">
            <JiGou ref="JiGou" />
        </div>
    </div>
</template>

<script>
import TodayNorthAmount from "./TodayNorthAmount.vue";
import HistoryNorthAmount from "./HistoryNorthAmount.vue";
import HistoryNorthData from "./HistoryNorthData.vue";
import GeGu from "./GeGu.vue";
import BanKuai from "./BanKuai.vue";
import JiGou from "./JiGou.vue";

export default {
    name: "LuGuTong",
    components: {
        TodayNorthAmount,
        HistoryNorthAmount,
        HistoryNorthData,
        GeGu,
        BanKuai,
        JiGou,
    },
    data() {
        return {
            curNav: 0,
            navs: ["资金概况", "个股", "板块", "机构"],

        };
    },
    filters: {
        formateTag: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "交易中";
            if (v < 0) return "已结束";
        },
        formatePrefixData: function (v) {
            if (v == undefined || v == null) return "--";
            if (v > 0) return "+" + v;
            if (v < 0) return v;
        },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
    },
    mounted: function () {
        this.scrollFixed();

    },
    methods: {
        scrollFixed: function () {
            var ot = this.$refs.content.offsetTop;
            var bar = this.$refs.nav;
            window.onscroll = function () {
                var st = document.documentElement.scrollTop;
                // console.log(st,ot)
                if (st > ot) {
                    bar.classList.add("fixed");
                } else {
                    bar.classList.remove("fixed");
                }
            };
        },
        /**
         * 主nav切换
        */
        onChangeNav: function (item, i) {
            this.curNav = i;
            // 机构模块重新加载表格尺寸
            if (i == 3) {
                this.$refs.JiGou.chartResize();
            }
        }
    },
};
</script>
